import React from "react";
import { api } from "../../api/api";
import { AutoForm } from "../../core/form/AutoForm";
import { AdvancedFileUpload } from "../../core/form/FileUpload";
import { DataContext, useDataContext } from "../../core/hooks/useData";
import { Modal } from "../../core/ui/Modal";
import { Table } from "../../core/ui/Table";
import { account_wf, doc_ref } from "../../types";
import { closestIndex, closestKey } from "../../core/utils/dom";
import { formatBytes } from "rant-utils";

export function EditWorkflowModal(props: {
	awf: account_wf,
	onCancel: () => void,
	onSave: (awf: account_wf) => void,
}) {

	const title = props.awf.title;

	const context = useDataContext({ 
		initialValue: { ...props.awf },
	});
	
	const [, refresh] = React.useState({});

	return (
		<DataContext.Provider value={context}>
			<Modal
				title={"Edit - " + title}
				size="width-50vw"
				onCancel={props.onCancel}
				saveOnEnterKey={false}
				onSave={() => {
					props.onSave(context.value);
				}}
			>
				<AutoForm fields={[
					{ prop: "title", title: "Title", options: { required: true } },
				]} />

				<div className="flex vert align-start gap-10">
					<fieldset className="width-100pc margin-top-10 flex horiz align-start">
						<legend>Documents</legend>
						
						<Table
							cols={[
								{ id: "title", name: "Name" },
								{ id: "sizeBytes", name: "Size" },
								{ id: "actions", name: "Actions" },
							]}
							items={props.awf.resources.docs}
							render={{
								colTitle: (c) => {
									return c.name;								
								},
								colValue: (r: any, c) => {
									if (c.id === "sizeBytes") return formatBytes(r.sizeBytes);

									if (c.id === "actions") {
										return (
											<button
												className="action"
												data-key="delete"
											>Delete</button>
										)
									}

									return r[c.id];
								}
							}}
							onClick={(e) => {
								const rowIndex = closestIndex(e.target, ".row");
								if (rowIndex < 0) return;

								const row = props.awf.resources.docs[rowIndex];

								const btn = closestKey(e.target, ".action");
								if (!btn) return;

								if (btn === "delete")

									api.account_wf_resource_del({
										id: props.awf.id,
										blob: row.blob,
									}).then(() => {
										props.awf.resources.docs.splice(rowIndex, 1);
										refresh({});

									}).catch(() => {

									});
								}
							}
						/>
					</fieldset>

					<fieldset className="width-100pc flex horiz align-start">
						<legend>Upload file</legend>
						<AdvancedFileUpload
							multiple={false}
							onStartUpload={(fileState) => {
								return api.account_resource_upload({
									name: fileState.file.name,
									data: fileState.data,
									associateWithAccountWorkflow: props.awf.id,
								});
							}}
							onUploadComplete={(result: doc_ref) => {
								props.awf.resources.docs.push(result);
								refresh({});
							}}
						/>
					</fieldset>
				</div>
			</Modal>
		</DataContext.Provider>
	);
}